import { SxProps, Theme } from '@mui/material';

export const hdmSkucomparerStyles: Record<'container' | 'table' | 'header', SxProps<Theme>> = {
	container: (theme) => ({
		width: '100%',
		background: 'white',
		overflowX: 'auto',
		padding: '10px',
		[theme.breakpoints.up('md')]: {
			padding: '20px',
		},
	}),
	header: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginBottom: 4,
	},
	table: {
		display: 'flex',
		flexDirection: 'column',
	},
};

export const columnStyles: Record<'container', SxProps<Theme>> = {
	container: {
		flex: 1,
		flexShrink: 0,
		padding: 1.5,
		flexDirection: 'column',
		justifyContent: 'space-between',
		gap: 2,
		minWidth: 130,
	},
};

export const rowStyles: Record<'container', SxProps<Theme>> = {
	container: {
		display: 'flex',
		borderBottomWidth: 1,
		borderBottomStyle: 'solid',
		borderBottomColor: 'grey.100',
	},
};
export const columnProductStyles: Record<
	'productName' | 'buttonsContainer' | 'productLink' | 'addToCartButton' | 'addToWishlistButton',
	SxProps<Theme>
> = {
	productName: (theme) => ({
		textTransform: 'capitalize',
		fontSize: '0.8rem',
		wordBreak: 'break-all',
		[theme.breakpoints.up('md')]: {
			fontSize: '1rem',
			wordBreak: 'break-word',
		},
	}),
	productLink: {
		'&:hover': {
			textDecoration: 'underline',
		},
	},
	buttonsContainer: (theme) => ({
		display: 'flex',
		gap: 1,
		flexDirection: 'column',
		[theme.breakpoints.up('md')]: {
			flexDirection: 'row',
			alignItems: 'center',
		},
	}),
	addToCartButton: {
		height: 40,
	},
	addToWishlistButton: {
		height: 40,
		paddingLeft: 1,
		paddingRight: 1,
		paddingTop: 0,
		paddingBottom: 0,
		flexDirection: 'column',
		color: 'grey.400',
	},
};

export const columnTextStyles: Record<'container' | 'text' | 'name', SxProps<Theme>> = {
	container: {
		alignItems: 'center',
		justifyContent: 'center',
		gap: 1,
	},
	name: (theme) => ({
		margin: 0,
		color: 'grey.300',
		display: 'inline',
		[theme.breakpoints.up('lg')]: {
			display: 'none',
		},
	}),
	text: {
		margin: 0,
		textTransform: 'capitalize',
	},
};

export const columnTitleStyles: Record<'container' | 'text', SxProps<Theme>> = {
	container: {
		width: '12rem',
		flex: 'unset',
	},
	text: {
		margin: 0,
		fontWeight: '600 !important',
	},
};

export const comparingWithControlsStyle: Record<'button', SxProps<Theme>> = {
	button: {
		padding: 1,
		color: 'grey.400',
	},
};
